import Utility from '../../../../../../../util/utilityfunctions';
import {dashboardChartColors} from '../../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../../util/utils';
import {getPercent} from '@ey/utils';

import {config as barchartColumnConfig} from '../../../common/BarchartColumn';

export const prop = 'status';
export const id = 'itColumn';

export const config = (labels) =>
	barchartColumnConfig({
		fullId: id,
		label: labels.itlabel,
		prop,
		getSeries: (item) => [
			{
				name: utilLabels.nonTesting,
				data: [item.itConTotal - item.itConTested + (item.itConSubTotal - item.itConSubTested)],
				color: dashboardChartColors.orange[2],
				control: item.itConTotal - item.itConTested,
				subs: item.itConSubTotal - item.itConSubTested
			},
			{
				name: utilLabels.testing,
				data: [item.itConTested + item.itConSubTested],
				color: dashboardChartColors.orange[1],
				control: item.itConTested,
				subs: item.itConSubTested
			}
		],
		tooltipFormatter: (item, numberFormat, series) =>
			`<span class="motif-body2-default-light">${series.series.name} | ${Utility.getFormattedNumber(
				numberFormat,
				series.y
			)} (${getPercent(
				series.y,
				item.itConTotal + item.itConSubTotal
			)}%)<span><br><span class="motif-body2-default-light">${Utility.getFormattedNumber(
				numberFormat,
				series.series.userOptions.control
			)} ${utilLabels.controls}</span><br><span class="motif-body2-default-light">${Utility.getFormattedNumber(
				numberFormat,
				series.series.userOptions.subs
			)} ${utilLabels.substantiveProcedures}</span>`
	});
